import { Tag } from 'antd';
import { X } from 'feather-icons-react';

type SearchResult = {
  type: 'deal' | 'site' | 'app';
  id: string;
  displayName: string;
};

type PublisherMappingChipsProps = {
  entities: SearchResult[];
  onRemove: (entity: SearchResult) => void;
};

export const PublisherMappingChips = ({ entities, onRemove }: PublisherMappingChipsProps) => {
  const deals = entities.filter((e) => e.type === 'deal');
  const sites = entities.filter((e) => e.type === 'site');
  const apps = entities.filter((e) => e.type === 'app');

  const renderSection = (title: string, items: SearchResult[], count: number) => {
    if (items.length === 0) return null;

    return (
      <div className="flex flex-col gap-2">
        <div className="text-base-sm font-medium text-secondary-black">
          {title} ({count})
        </div>
        <div className="flex flex-wrap gap-2">
          {items.map((entity) => (
            <Tag
              key={`${entity.type}:${entity.id}`}
              closable
              onClose={() => onRemove(entity)}
              closeIcon={<X size={12} />}
              className="flex items-center gap-1 px-3 py-1 m-0"
            >
              {entity.displayName}
            </Tag>
          ))}
        </div>
      </div>
    );
  };

  if (entities.length === 0) {
    return (
      <div className="text-center py-8 text-primary-gray-500 text-base-sm">
        No mappings added yet. Use the search above to add deals, sites, or apps.
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 p-4 border border-primary-gray-200 rounded-lg bg-primary-gray-50">
      {renderSection('Deals', deals, deals.length)}
      {renderSection('Sites', sites, sites.length)}
      {renderSection('Apps', apps, apps.length)}
    </div>
  );
};
